import axios from '../../axios'
import { makeObservable } from 'mobx'
// import { toast } from 'react-toastify'
import { ObjectType } from './types'
import { OBJECT_TYPE } from 'app/constants'

export class SharingStore {
  constructor() {
    makeObservable(this, {})
  }

  reset = () => {}

  getSharingObject = async (objectType: ObjectType, objectId: number) => {
    const url =
      objectType === OBJECT_TYPE.FOLDER
        ? '/prediction-services/api/v1/share/object'
        : '/api/v1/share/object'
    return await axios(`${url}/${objectType}/${objectId}`).then(
      ({ data }) => data?.[0]
    )
  }

  searchGroupsByName = async (searchValue: string) => {
    return await axios(
      `/api/v1/user/group?name=${encodeURIComponent(searchValue)}`
    ).then(({ data }) => data)
  }

  // Share the objects with the specified list of users and groups, 
  // the users and groups that are not in this list will lose the share
  shareObject = async (params: {
    objectType: ObjectType
    objectIds: number[]
    emailIds: string[]
    groups: string[]
    shareDetails: boolean,
    message: string
  }) => {
    const url =
      params.objectType === OBJECT_TYPE.FOLDER
        ? '/prediction-services/api/v1/share'
        : '/api/v1/share'     
    return await axios.post(url, params).then(({ data }) => data)
  }

  // Share the objects with new list of users and groups, 
  // the action will not remove the share information of the users and groups that are not in this list.
  addShareObjectInf = async (params: {
    objectType: ObjectType
    objectIds: number[]
    emailIds: string[]
    groups: string[]
    shareDetails: boolean,
    message: string
  }) => {
    const url =
      params.objectType === OBJECT_TYPE.FOLDER
        ? '/prediction-services/api/v1/share/add'
        : '/api/v1/share/add'     
    return await axios.post(url, params).then(({ data }) => data)
  }
}

export const sharingStore = new SharingStore()
